import React from "react";
import { Subscribe } from "unstated";
import PlayerContainer from "../state";
import { notes, octaves } from "../ragas";
import {KaalamSelector} from "./kaalam-selector";

export class ShrutiSelector extends React.Component {
    constructor(props) {
        super(props);
        this.state = { expandedS: false, expandedO: false, selectedShruti: ["G", 3] };
        this.getDropDownStyleS = this.getDropDownStyleS.bind(this);
        this.getDropDownStyleO = this.getDropDownStyleO.bind(this);
        this.toggleExpandedS = this.toggleExpandedS.bind(this);
        this.toggleExpandedO = this.toggleExpandedO.bind(this);
        // this.setRaga = this.setRaga.bind(this);
    }

    getDropDownStyleS() {
        if (!this.state.expandedS) return "dropdown shruti-selector";
        else return "dropdown shruti-selector is-active";
    }

    getDropDownStyleO() {
        if (!this.state.expandedO) return "dropdown shruti-selector";
        else return "dropdown shruti-selector is-active";
    }

    toggleExpandedS() {
        this.setState({ expandedS: !this.state.expandedS});
    }

    toggleExpandedO() {
        this.setState({ expandedO: !this.state.expandedO});
    }

    render() {
        return (
            <Subscribe to={[PlayerContainer]}>
                {playerContainer => {
                    return (
                        <div>
                            <div className={this.getDropDownStyleS()}>
                                <div className="dropdown-trigger" onClick={this.toggleExpandedS}>
                                    <button className="button" aria-haspopup="true" aria-controls="dropdown">
                                        <span className="shruti">
                                            {playerContainer.state.shruti}
                                        </span>
                                        <span className="icon is-small">
                                            <i className="fas fa-angle-down" aria-hidden="false"></i>
                                        </span>
                                    </button>
                                </div>
                                <div className="dropdown-menu" role="menu">
                                    <div className="dropdown-content">
                                        {notes.map((shruti) => (
                                            <a href="#" className="dropdown-item" onClick={() => {
                                                playerContainer.setShruti(shruti);
                                                this.toggleExpandedS();
                                            }}>
                                                {shruti}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                            </div>
                                <div className={this.getDropDownStyleO()}>
                                    <div className="dropdown-trigger" onClick={this.toggleExpandedO}>
                                        <button className="button" aria-haspopup="true" aria-controls="dropdown">
                                            <span className="octave">
                                                {playerContainer.state.octave}
                                            </span>
                                            <span className="icon is-small">
                                                <i className="fas fa-angle-down" aria-hidden="false"></i>
                                            </span>
                                        </button>
                                    </div>
                                    <div className="dropdown-menu" role="menu">
                                        <div className="dropdown-content">
                                            {octaves.map((octave) => (
                                                <a href="#" className="dropdown-item" onClick={() => {
                                                    playerContainer.setOctave(octave);
                                                    this.toggleExpandedO();
                                                }}>
                                                    {octave}
                                                </a>
                                            ))}
                                        </div>
                                    </div>
                                    <KaalamSelector />
                                </div>
                               
                            </div>
                    );
                }}
            </Subscribe>
        );
    }
}
